import React from 'react';
import { makeStyles } from '@material-ui/styles';
import MapView from './MapView';

import {useState, useEffect, useCallback, useRef} from 'react'

import PanelButtons from './PanelButtons';
import OutputAddress from './OutputAddress';

import {
  getAddressStatus,
  isGeopoint
  } from '../hooks/geo-location'; 
import GeopointInput from './GeopointInput';
import { Paper, Typography } from '@material-ui/core';
import { getDistance } from '../hooks/orders-fees';
import WarnningBox from './WarnningBox';
import { log } from '../hooks/debug';

const useStyles = makeStyles((theme) => ({

  containerPage:{
   
  },
  paddingSearch: {
    //backgroundColor:"red",
   // height: "110vh",
  },

  containerAddress:{
    position: "fixed",
    top: 0,
    width: "100%",
  
    [theme.breakpoints.up('md')]: {
      padding:  theme.spacing(2),
      width: "35%",
    },
   
  },

  infoBox: { 
      display: 'flex',    
      backgroundColor: theme.palette.background.info,
      marginTop: theme.spacing(1.5), 
      marginBottom: theme.spacing(1.5),  
      marginLeft: theme.spacing(1), 
      marginRight:theme.spacing(1),      
      padding: theme.spacing(1),
      borderRadius: "0.5rem",
   },


   infoError: { 
    display: 'flex',    
    marginLeft: theme.spacing(1), 
    marginRight:theme.spacing(1),
 },
}));

const mapStyle = {
  height: "100vh",
  width: "100vw"
};




const defaultFullAddres = {
  address:"Current position", 
  details: undefined,
}; 


export default function CoordinatesView(props) {
 
  const classes = useStyles();

  const {
     onCancel,
     onFinish,
     defaultAddress,
     title,
     requiresGeopoint, 
     refGeopoint,
     refMaxDistance, 
     strings, 
     userPosition
    } = props; 
  
   const formAddress =  useRef(defaultAddress ? defaultAddress: defaultFullAddres);
   const resetGeopoint = useRef(false); 
  

  const [geopoint, setGeopoint] = useState(
                                          isGeopoint(formAddress.current.geopoint)
                                          ? formAddress.current.geopoint: null);

  const [currentPosition, setCurrentPosition] = useState(userPosition);
  const [pointer, setPointer] = useState(null);
  const [action, setAction] = useState(null);
  const [coordinatesOk, setCoordinatesOK] = useState(false); 
  const [showCurrent, setShowCurrent] = useState(false)
  const [error, setError] = useState(null);
  

  useEffect(() => {
      log.message('CoordinatesView',"Starting useEffect, currentPosition: ",currentPosition);    
      const formGeopoint = getFormGeopoint(); 
      if(formGeopoint){
        log.message('CoordinatesView',"starting with google geopoint",formGeopoint);
        setGeopoint(formGeopoint)
        onAddCoordinates(formGeopoint)
        console.debug("starting with google geopoint");
      }else {
        log.message('CoordinatesView',"starting current position",currentPosition);
        setPointer({
          geopoint: currentPosition,
          marker: "sight"
        })
        console.debug("starting current position");
      }
      log.message('CoordinatesView',"starting poiner",pointer);
    }, []);

    const setErrorDistance=(distance,maxDistance)=>{
      let str = strings.error_out_of_range; 
      let message = str
      .replace("${store}",maxDistance)
      .replace("${user}", distance.toFixed(2));
      //console.debug("AddressPage: ErrorDistance:", message);
      setError({
        message: message,
        code:"maxDistance",
      })
    }  

  const getFormGeopoint = ()=>{
    if(formAddress.current && isGeopoint(formAddress.current.geopoint))
      return formAddress.current.geopoint
    else return null
  }

  const handlerBackToPlace = () => {
    //console.debug("handlerBackToPlace");
    if(onCancel)
        onCancel()
  }

  const   handlerBackToGeopoint  = () => {
    //console.debug("handlerBackToGeopoint ");
    setCoordinatesOK(false)
    setPointer({
      geopoint: geopoint,
      marker: "sight"
    })
  }

  const handlerFinish = () => {
    const address = {...formAddress.current, 
                     geopoint: geopoint
                    };
    
    const geopointStatus = getAddressStatus(formAddress.current,geopoint); 
    if(geopointStatus){
      address.geopoint.type = geopointStatus; 
    }
      
    //console.debug("handlerFinish", address);
    if(onFinish)
        onFinish(address);
  }


  const handlerSightChange= (sight)=>{
    if(resetGeopoint.current==true){
      let newGeopoint = getFormGeopoint()
      setGeopoint(newGeopoint); 
      resetGeopoint.current=false
      return;
    }
  
    if(refGeopoint){
       const distance = getDistance(sight,refGeopoint)
       if(distance && distance>refMaxDistance)
            setErrorDistance(distance,refMaxDistance)
       else setError(null)
    }
    setGeopoint(sight)
  }

  const handlerReset= ()=>{
    //console.debug("handlerResetCurrent");
    resetGeopoint.current=true; 
    setError(null); 
    let newCenter = getFormGeopoint()
    if(!newCenter){
      newCenter = currentPosition
    }
    
    setAction({
      geopoint:newCenter, 
      type:'center'
    })
  }

  const onAddCoordinates = (coordinates) => {
    //console.debug("handlerAddCoordinates", coordinates);
    setCoordinatesOK(true)
    setPointer({
      geopoint: coordinates, 
      marker: "place"
    })
    setAction({
      type:'zoom', 
      zoom:18
    })
  }

  const onEditCoordinates= (coordinates)=>{
    //console.debug("handlerEdit");
    setPointer({
      geopoint: coordinates, 
      marker: "sight"
    })
    setAction({
      type:'zoom', 
      zoom:18
    })
    setCoordinatesOK(false)
  }


  return (
    <div className = {classes.containerPage}>   
         
      
          { pointer && 
          
                <MapView      
                  pointer = {pointer}
                  current = { showCurrent ? currentPosition: undefined}
                  action = {action}  
                  mapStyle = {mapStyle}
                  onSightChange = {!coordinatesOk ? handlerSightChange : undefined}
                />
          }
      
         {    pointer &&     
            <Paper   className={classes.containerAddress} elevation={4}>
              <OutputAddress
                  fullAddress={formAddress.current}
                  addressTitle={title}
                  iconColor = "accent"
              />
             
             {  pointer  && coordinatesOk && 
              <GeopointInput
                geopoint={geopoint}
                editing = {false}
                hintEmpty = {strings.no_coordinates}
                onAction = { () => onEditCoordinates(geopoint)} 
                strings={strings}
                enabled = {geopoint}
              />
             }

              { pointer && !coordinatesOk && 
              <GeopointInput
                geopoint={geopoint}
                editing = {true}
                hintEmpty = {strings.no_coordinates}
                onAction = { handlerReset} 
                strings={strings} 
                enabled = {geopoint}
              />
             }

             { !error && !geopoint && !coordinatesOk && 
              <div className={classes.infoBox}>
              <Typography variant ='body1' >{strings.help_ajust_coordinates}</Typography>
              </div>
              
             }

              {error && 
               <div className = {classes.infoError}>   
                    <WarnningBox
                      message={error.message}
                      backgroundColor='pink'
                    />
                </div>
              }

            </Paper>        
          } 

          {
            
          }
         
          {  pointer && !coordinatesOk &&             
              <PanelButtons                    
                labelCancel={strings.action_back}
                labelNext={strings.action_done}
                onClickCancel={handlerBackToPlace}
                onClickNext={()=>onAddCoordinates(geopoint)}   
                nextDisabled = {requiresGeopoint ? !geopoint || error: true }  
                nextColor = 'alert'        
              />   
          } 

          {  pointer && coordinatesOk &&             
              <PanelButtons                    
                labelCancel={strings.action_back}
                labelNext={strings.action_confirm}
                onClickCancel={handlerBackToPlace}
                onClickNext={handlerFinish}   
                nextDisabled = {requiresGeopoint ? !geopoint : true }          
              />   
          } 
         
    </div>
  );
}
